import { render, staticRenderFns } from "./SpecialtiesList.vue?vue&type=template&id=971ba788"
import script from "./SpecialtiesList.vue?vue&type=script&lang=js"
export * from "./SpecialtiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports